import { render, staticRenderFns } from "./AutoTraderModal.vue?vue&type=template&id=47dcd32c&scoped=true"
import script from "./AutoTraderModal.vue?vue&type=script&lang=js"
export * from "./AutoTraderModal.vue?vue&type=script&lang=js"
import style0 from "./AutoTraderModal.vue?vue&type=style&index=0&id=47dcd32c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dcd32c",
  null
  
)

export default component.exports